import { render, staticRenderFns } from "./EditHolidayPlan.vue?vue&type=template&id=ec4e59a2&"
import script from "./EditHolidayPlan.vue?vue&type=script&lang=js&"
export * from "./EditHolidayPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports